import React from 'react'
import './HullAddDisclaimer.scss'

export const HullAddDisclaimer = ({className}) => <div className={`box add-disclaimer ${className}`}>
Only equipment related to the drone operation is eligible for coverage. For example, attachable cameras or a ground control station are eligible, but standalone cameras or lenses are not.
</div>